export class TriggerEvent {

  constructor() {
    this.setTypeCode(_TYPE_CODES.RECEIVED);
  }

  setTypeCode(typeCode) {
    this.typeCode = typeCode;
    this.parameters = TriggerEventType.forCode(typeCode).defaultParamsFn();
  }

  isTypeReceived() {
    return this.typeCode === _TYPE_CODES.RECEIVED;
  }
  isTypeRoutedTo() {
    return this.typeCode === _TYPE_CODES.ROUTED_TO;
  }
  isTypeTagged() {
    return this.typeCode === _TYPE_CODES.TAGGED;
  }
  isTypeNotHandledAfter() {
    return this.typeCode === _TYPE_CODES.STILL_NOT_HANDLED_AFTER;
  }
  isTypePutOnHoldSince() {
    return this.typeCode === _TYPE_CODES.PUT_ON_HOLD_SINCE;
  }
  isTypeFBPublicToPrivate() {
    return this.typeCode === _TYPE_CODES.FB_PUBLIC_ANSWERED_AS_PRIVATE;
  }
  isTypeArchivedByHuman() {
    return this.typeCode === _TYPE_CODES.ARCHIVED_BY_HUMAN;
  }
  isTypeAnsweredByHuman() {
    return this.typeCode === _TYPE_CODES.ANSWERED_BY_HUMAN;
  }
  isTypeHelpRequested() {
    return this.typeCode === _TYPE_CODES.HELP_REQUESTED;
  }
  isTypeHelpAnswered() {
    return this.typeCode === _TYPE_CODES.HELP_ANSWERED;
  }
  isTypeParentPublicationOlderThan() {
    return this.typeCode === _TYPE_CODES.PARENT_PUBLICATION_OLDER_THAN;
  }


  static fromBackEnd(backendEvent) {
    let result = null;
    if (backendEvent) {
      result = new TriggerEvent();
      result.typeCode = backendEvent.typeCode;
      result.parameters = angular.copy(backendEvent.parameters);
      if (   backendEvent.typeCode === 'routed-to' 
          && backendEvent.parameters && !backendEvent.parameters.routingTagId) {

        // Backend expects no routing tag id for this case
        result.parameters.routingTagId = -1;
      }
    }
    return result;
  }
}


export class TriggerEventType {

  constructor(code, defaultParamsFn) {
    this.code = code;
    this.defaultParamsFn = defaultParamsFn;
  }

  static codes() {
    return _TriggerEventTypes.map(t => t.code);
  }

  static values() {
    return _TriggerEventTypes;
  }

  static forCode(code) {
    return _TriggerEventTypes.filter(t => t.code === code)[0];
  }
}

const _TYPE_CODES = {
  RECEIVED: 'received',
  ROUTED_TO: 'routed-to',
  TAGGED: 'tagged',
  STILL_NOT_HANDLED_AFTER: 'still-not-handled-after',
  PUT_ON_HOLD_SINCE: 'put-on-hold-since',
  FB_PUBLIC_ANSWERED_AS_PRIVATE: 'fb-public-answered-as-private',
  ARCHIVED_BY_HUMAN: 'archived-by-human',
  ANSWERED_BY_HUMAN: 'answered-by-human',
  HELP_REQUESTED: 'help-requested',
  HELP_ANSWERED: 'help-answered',
  PARENT_PUBLICATION_OLDER_THAN: 'parent-publication-older-than'
}

const _TriggerEventTypes = [
  new TriggerEventType(_TYPE_CODES.RECEIVED,                      () => ({})), 
  new TriggerEventType(_TYPE_CODES.ROUTED_TO,                     () => ({'routingTagId': null})),
  new TriggerEventType(_TYPE_CODES.TAGGED,                        () => ({'tagGroupId': null, 'tagId': null})),
  new TriggerEventType(_TYPE_CODES.STILL_NOT_HANDLED_AFTER,       () => ({'hoursNumber': null, 'hoursTypes': []})),
  new TriggerEventType(_TYPE_CODES.PUT_ON_HOLD_SINCE,             () => ({'hoursNumber': null, 'hoursTypes': []})),
  new TriggerEventType(_TYPE_CODES.FB_PUBLIC_ANSWERED_AS_PRIVATE, () => ({})),
  new TriggerEventType(_TYPE_CODES.ARCHIVED_BY_HUMAN,             () => ({})),
  new TriggerEventType(_TYPE_CODES.ANSWERED_BY_HUMAN,             () => ({})),
  new TriggerEventType(_TYPE_CODES.HELP_REQUESTED,                () => ({})),
  new TriggerEventType(_TYPE_CODES.HELP_ANSWERED,                 () => ({})),
  new TriggerEventType(_TYPE_CODES.PARENT_PUBLICATION_OLDER_THAN,       () => ({'hoursNumber': null, 'hoursTypes': []})),
];
